import * as StaticConfig from "../../StaticConfig";
import { TableauLocalizedStrings } from "../../Strings";

export function showErrorPage(
  doc: Document,
  strings: TableauLocalizedStrings,
  details: string[],
  communityLink: string,
  errorType?: string
) {
  const renderer = new ErrorPageRenderer(doc, strings);
  doc.body.replaceChildren(
    renderer.getBodyContents(details, communityLink, errorType)
  );

  doc
    .querySelectorAll('style,link[rel="stylesheet"]')
    .forEach((element) => element.remove());
}

class ErrorPageRenderer {
  doc: Document;
  strings: TableauLocalizedStrings;

  constructor(doc: Document, strings: TableauLocalizedStrings) {
    this.doc = doc;
    this.strings = strings;
  }

  private htmlEncode(html: string) {
    const div = this.doc.createElement("div");
    div.innerText = html;
    const encodedHtml = div.innerHTML;
    div.remove();
    return encodedHtml;
  }

  public getBodyContents(
    details: string[],
    communityLink: string,
    errorType?: string
  ) {
    const isPublic = StaticConfig.isPublic(this.doc);

    if (isPublic || details.length === 0 || details[0].length === 0) {
      const blockQuote = this.doc.createElement("blockquote");
      blockQuote.style.backgroundColor = "#eee";
      blockQuote.style.padding = "10pt";

      const paragraph = this.doc.createElement("p");
      paragraph.innerHTML = this.strings.getString("ErrorPageUnexpectedError");

      blockQuote.appendChild(paragraph);

      if (isPublic) {
        const lineBreak = this.doc.createElement("br");

        blockQuote.appendChild(lineBreak);

        blockQuote.insertAdjacentHTML(
          "beforeend",
          `${this.strings.ErrorPageHelpOnline(communityLink)}</a>.`
        );
      }

      return blockQuote;
    } else {
      const div = this.doc.createElement("div");
      div.style.padding = "15px";

      const errorDetails = this.doc.createTextNode(
        this.strings.getString("ErrorPageErrorDetails")
      );

      div.appendChild(errorDetails);

      const blockQuote = this.doc.createElement("blockquote");
      blockQuote.style.backgroundColor = "#eee";
      blockQuote.style.padding = "10pt";

      if (details.length && details[0].length) {
        const textInsideTable = this.doc.createElement("span");
        textInsideTable.className = "TextInsideTable";

        if (errorType && errorType.length) {
          textInsideTable.innerHTML = this.htmlEncode(errorType);
        }

        const ul = this.doc.createElement("ul");

        details.forEach((item: string) => {
          if (item.length) {
            const li = this.doc.createElement("li");
            li.innerHTML = this.htmlEncode(item);

            ul.appendChild(li);
          }
        });

        textInsideTable.appendChild(ul);

        blockQuote.appendChild(textInsideTable);
      }

      div.appendChild(blockQuote);

      div.appendChild(
        this.doc.createTextNode(this.strings.getString("ErrorPageClickRefresh"))
      );
      div.appendChild(this.doc.createElement("br"));
      div.appendChild(
        this.doc.createTextNode(
          this.strings.getString("ErrorPageContactTableauServer")
        )
      );

      return div;
    }
  }
}
